import React from "react";
import { Tag } from "@jem-open/jem-ui";
import { Layers, MapPin, Users as UsersIcon } from "lucide-react";
import { ReportScope } from "../services/model/ReportScope";

interface ScopeSummaryProps {
  scope: ReportScope;
}

const ScopeSummary = ({ scope }: ScopeSummaryProps): JSX.Element => {
  let Icon = UsersIcon;
  let kindLabel = "Roster";
  if (scope.kind === "site") {
    Icon = MapPin;
    kindLabel = "Site";
  } else if (scope.kind === "region") {
    Icon = Layers;
    kindLabel = "Region";
  }
  return (
    <div className="rounded-lg border border-greyscale-border bg-neutral-50 px-md py-sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-greyscale-text-caption mb-xxxs">
        Scope
      </p>
      <div className="flex items-center gap-xs flex-wrap">
        <Icon size={16} className="text-primary-brand-primary shrink-0" />
        <span className="text-sm font-semibold text-greyscale-text-title break-words min-w-0">
          {scope.label}
        </span>
        <Tag variant="drafted" size="sm">
          {kindLabel}
        </Tag>
      </div>
      {scope.kind === "site" && scope.region && (
        <p className="text-xs text-greyscale-text-caption mt-xxxs pl-lg">
          {scope.region}
        </p>
      )}
      {scope.kind === "roster" && scope.parentSite && (
        <p className="text-xs text-greyscale-text-caption mt-xxxs pl-lg">
          in {scope.parentSite}
        </p>
      )}
    </div>
  );
};

export default ScopeSummary;
